import React from 'react';
import {useNavigation} from "v4/features/front/navigation/contexts/NavigationContext";
import { resolveUrl } from "v4/features/front/navigation/utils/route.utils";
import TableLink from "v4/components/utils/TableLink/TableLink";

export default function DashboardQuotesListingTableRowAction({isWon, prospectId, rowId}) {
    const nativeIdentifier = isWon ? 'detail_won_quotes' : 'detail_quotes';
    const { getRouteByNativeIdentifier } = useNavigation();

    return (
        <>
            <TableLink href={`/${resolveUrl(getRouteByNativeIdentifier(nativeIdentifier)?.url, {prospect: prospectId})}/${rowId}`}/>
        </>
    )
}
